// Valores por defecto de typesOfDangers.
export const defaultTypesOfDangersSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultAction = () => {
    return "";
};

// Valor por defecto de typeOfDanger.
export const defaultTypeOfDanger = () => {
    return {
        id: null,
        name: null,
        version_id: null,
        color: null,
        priority: null,
        sga_type_of_danger_languages: [],
    };
};

// Valores por defecto de filterTypesOfDangersSga.
export const defaultFilterSgaTypesOfDanger = () => {
    return {
        name: null,
        version: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeTypesOfDangers.
export const defaultActiveTypesOfDangers = () => {
    return [];
};

export default {
    typesOfDangers: defaultTypesOfDangersSga(),
    action: defaultAction(),
    typeOfDanger: defaultTypeOfDanger(),
    filterTypesOfDangersSga: defaultFilterSgaTypesOfDanger(),
    activeTypesOfDangers: defaultActiveTypesOfDangers(),
};
